<template>
  <div>
    <el-form ref="dynamicValidateForm" label-width="100px" class="demo-dynamic" hidden>
       <el-form-item
        v-for="(n, index) in roles"
        :label="n.label + parseInt(index+1)"
        :key="n.id"
        :prop="'roles.' + index + '.value'"
      >
      <el-col :span="8">
        <!-- <el-input v-model="n.key" ></el-input> -->
        <el-select v-model="n.key" filterable clearable placeholder="请选择">
          <el-option
            v-for="item in roleList"
            :key="item.key"
            :label="item.description"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button @click.prevent="removeDom(n)" type="danger">删除</el-button>
      </el-col>
      </el-form-item>
      <el-form-item style="text-align:right;">
        <el-button @click="addDom()">新增参数</el-button>
      </el-form-item>
    </el-form>
    
    <el-input type="text" v-model="para.username"/>
    <el-input type="text" v-model="para.pwd"/>
    <el-button @click="login">login</el-button>
    <el-button @click="postexcelgetexcel">download</el-button>
    <el-button @click="getexcelgetExcelExchangeRate">下载2</el-button>
  </div>
</template>
<script>
import { queryrole, excelgetexcel, requestLogin, excelgetExcelExchangeRate} from '../api'
import qs from 'qs'
export default {
  data () {
    return {
      roles: [
        {
          key: '',
          value: '',
          label: '角色'
        }
      ],
      roleList: [],
      para: {
        username: 'admin',
        pwd: '111111',
      }
    }
  },
  methods: {
    getqueryrole () { //  角色查询
      let params = qs.stringify({
        isValid: true
      })
      queryrole(params).then(data => {
        console.log(data)
        this.roleList = data.data
      })
    },

    getexcelgetExcelExchangeRate () {
      let para = new URLSearchParams()
      let responseType = {
        responseType: 'blob'
      }
      excelgetExcelExchangeRate(para, responseType).then(res => {
        if (res > 2) {
          this.$message.error('请求失败')
        } else {
          console.log(res)
          // type 为需要导出的文件类型，此处为xls表格类型
          const blob = new Blob( [res], {type: 'application/vnd.ms-excel'} )
          // 兼容不同浏览器的URL对象
          const url = window.URL || window.webkitURL || window.moxURL
          // 创建下载链接
          const downloadHref = url.createObjectURL(blob)
          // 创建a标签并为其添加属性
          let downloadLink = document.createElement('a')
          downloadLink.href = downloadHref
          downloadLink.download = 'xxx.xlsx'
          // 触发点击事件执行下载
          downloadLink.click()
        }
      })
    },
    removeDom (item) { //  删除元素
      if (this.roles.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = this.roles.indexOf(item)
        if (index !== -1) {
          this.roles.splice(index, 1)
        }
      }
    },
    addDom () { //  增加参数
      this.roles.push({
        key: '',
        value: '',
        label: '角色'
      })
    },
    login () {
      var loginParams = qs.stringify({ 'loginName': this.para.username, 'pwd': this.para.pwd })
      console.log(loginParams)
      requestLogin(loginParams).then(data => {
        console.log(data)
        let { msg, code } = data
        if (code !== 10000) {
          this.$message({
            message: msg,
            type: 'error'
          })
        } else {
          sessionStorage.setItem('user', data.data.name)
          sessionStorage.setItem('roleCode', data.data.roleCode)
          this.$message.success('登录成功')
        }
      })
    },
    postexcelgetexcel () {
      let para = new URLSearchParams()
      let responseType = {
        responseType: 'blob'
      }
      excelgetexcel(para, responseType).then(res => {
        if (res > 2) {
          this.$message.error('请求失败')
        } else {
          console.log(res)
          // type 为需要导出的文件类型，此处为xls表格类型
          const blob = new Blob( [res], {type: 'application/vnd.ms-excel'} )
          // 兼容不同浏览器的URL对象
          const url = window.URL || window.webkitURL || window.moxURL
          // 创建下载链接
          const downloadHref = url.createObjectURL(blob)
          // 创建a标签并为其添加属性
          let downloadLink = document.createElement('a')
          downloadLink.href = downloadHref
          downloadLink.download = 'xxx.xls'
          // 触发点击事件执行下载
          downloadLink.click()
        }
      })
    }
  },
  mounted () {
    // this.getqueryrole()
    // this.posttestgetexcel()
  }
}
</script>

